module.exports = __webpack_public_path__ + "img/big_1_75.930c2aac.png";